import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import List from '@mui/material/List';
import { styled } from '@mui/material/styles';
import SideMenuLinkItem from './SideMenuLinkItem';
import AddPhotoAlternateOutlinedIcon from '@mui/icons-material/AddPhotoAlternateOutlined';
import DashboardCustomizeOutlinedIcon from '@mui/icons-material/DashboardCustomizeOutlined';
import UserButton from './UserButton';
import SupportButton from '../common/SupportButton';
import ApplicationButton from './ApplicationButton';
import NetworkButton from './NetworkButton';

const SideMenuDivider = styled(Divider)(({ theme }) => ({
  margin: theme.spacing(1, 1, 1.5, 1),
  backgroundColor: 'rgb(200 207 220 / 42%)',
  borderWidth: 0,
  height: '1px',
}));

const SideMenu = () => {

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'space-between',
        maxHeight: '100%',
        width: 60,
        backgroundColor: 'white',
        py: 2,
      }}>

      <List sx={{
        '&': {
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'start',
          flexDirection: 'column',
          width: '100%',
          gap: 1,
          p: 0,
        },
      }}>
        <NetworkButton />
        <ApplicationButton />
        <Box sx={{width:'100%'}}>
          <SideMenuDivider />
        </Box>
        <SideMenuLinkItem
          title={"Create Ads"}
          to={`/services`}
          icon={<AddPhotoAlternateOutlinedIcon style={{ fontSize: 24, padding: 0 }} />}
          style={{ width: 'auto', paddingBottom: 4 }}
        />
        <SideMenuLinkItem
          title={"Cabinet"}
          to={`/cabinet`}
          icon={<DashboardCustomizeOutlinedIcon style={{ fontSize: 24, padding: 0 }} />}
          style={{ width: 'auto', paddingBottom: 4 }}
        />
      </List>

      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flexDirection: 'column',
        gap: 2,
        width: '100%',
      }}>
        <SupportButton />
        <UserButton />
      </Box>
    </Box>
  );
};
export default SideMenu;